<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<h3 matDialogTitle>Logout</h3>

<mat-dialog-content>
    <span>You are signed in as {{ (user$ | async)?.username }}.<br/>Are you sure you want to log out?</span>
</mat-dialog-content>

<mat-dialog-actions [attr.align]="'end'">
    <button mat-button matDialogClose>Cancel</button>
    <button mat-button (click)="logout()">Logout</button>
</mat-dialog-actions>
